import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import GatsbyImage from "gatsby-image"
import Layout from "../components/Layout"
import LayoutContainer from "../components/LayoutContainer"
import LandingService from "../components/LandingService"
import DarkBackgroundSVG from "../components/DarkBackgroundSVG"
import LightBackgroundSVG from "../components/LightBackgroundSVG"
import { ABOUT_US_ROUTE, FOR_SALE_ROUTE, SHOWCASE_ROUTE } from "../constants"
import Icon from "../components/Icon"
import ContactForm from "../components/ContactForm"

const landingButtonClass =
  "block w-full sm:w-64 text-center shadow bg-teal-600 hover:bg-teal-500 focus:shadow-outline focus:outline-none text-white py-2 px-8 rounded"
declare var require: any
if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]')
}
const TopAngleSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 480 1400"
    width="100%"
    fill="currentColor"
  >
    <path d="M472.5 0L0 1400L-787.5 1400L-315 0L472.5 0Z" />
  </svg>
)
const BottomAngleSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 480 1400"
    width="100%"
    fill="currentColor"
  >
    <path d="M1270.46 0L797.96 1400L10.46 1400L482.96 0L1270.46 0Z" />
  </svg>
)
const iconWidth = 56
const CartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 496 496"
    width={`${iconWidth}px`}
    fill="currentColor"
  >
    <path d="M136 240c-17.648 0-32 14.352-32 32s14.352 32 32 32 32-14.352 32-32-14.352-32-32-32zm0 48c-8.824 0-16-7.176-16-16s7.176-16 16-16 16 7.176 16 16-7.176 16-16 16z" />
    <path d="M440 320h-36.688l8-8H448v-40c0-13.232-10.768-24-24-24h-8.664c-1.12-6.664-3.76-12.776-7.336-18.216V48h32V24c0-13.232-10.768-24-24-24H80C66.768 0 56 10.768 56 24v24h32v181.784c-3.576 5.44-6.216 11.544-7.336 18.216H72c-13.232 0-24 10.768-24 24v40h36.688l8 8H56c-13.232 0-24 10.768-24 24v128c0 13.232 10.768 24 24 24h64c13.232 0 24-10.768 24-24v-48h208v48c0 13.232 10.768 24 24 24h64c13.232 0 24-10.768 24-24V344c0-13.232-10.768-24-24-24zM72 32v-8c0-4.416 3.584-8 8-8h336c4.416 0 8 3.584 8 8v8H72zm320 88v94.488c-7.072-4.104-15.256-6.488-24-6.488h-6.56c4.216-7.192 6.56-15.384 6.56-24 0-26.472-21.528-48-48-48s-48 21.528-48 48c0 8.616 2.344 16.808 6.56 24H200v-16h-16v16h-16v-16h-16v16h-24c-8.744 0-16.928 2.384-24 6.488V120h240v-16H104V48h288v56h-32v16h32zm-102.864 56c3.576-13.768 15.992-24 30.864-24s27.288 10.232 30.864 24h-61.728zM312 192v16h-12.688c-5.024-4.32-8.6-9.808-10.216-16H312zm16 0h22.912c-1.616 6.192-5.192 11.68-10.216 16H328v-16zM128.008 355.056l-27.576 13.792 7.16 14.312L128 372.944v14.112l-27.576 13.792 7.16 14.312L128 404.944v14.112l-27.576 13.792 7.16 14.312L128 436.944v14.112l-27.576 13.792 7.16 14.312L128 468.944V472c0 4.416-3.584 8-8 8H96v-16H80v16H56c-4.416 0-8-3.584-8-8v-3.056l20.424 10.208 7.16-14.312L48 451.056v-14.112l20.424 10.208 7.16-14.312L48 419.056v-14.112l20.424 10.208 7.16-14.312L48 387.056v-14.112l20.424 10.208 7.16-14.312L48 355.056V344c0-.984.232-1.904.56-2.776l19.864 9.928 7.16-14.312-1.696-.84H80v112h16V336h6.112l-1.688.84 7.16 14.312 12.368-6.184a87.813 87.813 0 008.056 4.856v5.232zm224 52.944H144v-51.648A88.244 88.244 0 00169.144 360h157.72c8.64 0 17.08-1.256 25.144-3.648V408zm-25.144-64h-157.72c-19.232 0-37.312-7.496-50.912-21.088L91.312 296H64v-24c0-4.416 3.584-8 8-8h24v-8c0-17.648 14.352-32 32-32h240c17.648 0 32 14.352 32 32v8h24c4.416 0 8 3.584 8 8v24h-27.312l-26.912 26.912c-13.6 13.592-31.68 21.088-50.912 21.088zM448 355.056l-27.576 13.792 7.16 14.312L448 372.944v14.112l-27.576 13.792 7.16 14.312L448 404.944v14.112l-27.576 13.792 7.16 14.312L448 436.944v14.112l-27.576 13.792 7.16 14.312L448 468.944V472c0 4.416-3.584 8-8 8h-24v-16h-16v16h-24c-4.416 0-8-3.584-8-8v-3.056l20.424 10.208 7.16-14.312L368 451.056v-14.112l20.424 10.208 7.16-14.312L368 419.056v-14.112l20.424 10.208 7.16-14.312L368 387.056v-14.112l20.424 10.208 7.16-14.312L368 355.056v-5.232a86.061 86.061 0 008.056-4.856l12.368 6.184 7.16-14.312-1.696-.84H400v112h16V336h6.112l-1.688.84 7.16 14.312 19.864-9.928c.32.872.552 1.792.552 2.776v11.056z" />
    <path d="M392 272c0-17.648-14.352-32-32-32s-32 14.352-32 32 14.352 32 32 32 32-14.352 32-32zm-32 16c-8.824 0-16-7.176-16-16s7.176-16 16-16 16 7.176 16 16-7.176 16-16 16zM184 312h128v16H184zM184 280h128v16H184z" />
  </svg>
)
const iconMap = {
  road: <Icon name="road" width={iconWidth} />,
  cart: CartIcon,
  cogs: <Icon name="cogs" width={iconWidth} />,
  tools: <Icon name="tools" width={iconWidth - 10} />,
}

const PageContainer: React.FC = () => {
  const pageData = useStaticQuery(graphql`
    query {
      content {
        landingBannerHeader
        landingBannerMessage
        landingService1Icon
        landingService2Icon
        landingService3Icon
        landingService4Icon
        landingService1Header
        landingService2Header
        landingService3Header
        landingService4Header
        landingService1Message
        landingService2Message
        landingService3Message
        landingService4Message
        landingShowcaseTopText
        landingShowcaseBottomText
        landingAboutParagraph1
        landingAboutParagraph2
        landingContactUsParagraph
        landingBannerImage {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingShowcaseImage1 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingShowcaseImage2 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingShowcaseImage3 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingShowcaseImage4 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingShowcaseImage5 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingLogoImage1 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingLogoImage2 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingLogoImage3 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingLogoImage4 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingLogoImage5 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingAboutImage1 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        landingAboutImage2 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)
  const {
    landingBannerHeader,
    landingBannerMessage,
    landingBannerImage,
    landingShowcaseTopText,
    landingShowcaseBottomText,
    landingAboutParagraph1,
    landingAboutParagraph2,
    landingContactUsParagraph,
  } = pageData.content
  const landingServices = Array.from({ length: 4 }).map((val, i) => {
    return {
      icon: pageData.content[`landingService${i + 1}Icon`],
      header: pageData.content[`landingService${i + 1}Header`],
      message: pageData.content[`landingService${i + 1}Message`],
    }
  })
  return (
    <>
      <section className="relative pb-12 py-24 bg-white min-h-screen flex items-center">
        <div className="hidden sm:block absolute top-0 left-0 text-teal-300 z-0 opacity-75 w-12%">
          {TopAngleSVG}
        </div>
        <LayoutContainer>
          <div className="flex relative z-10 items-center flex-wrap -m-4">
            <div className="w-full lg:w-6/12 p-4">
              <div className="max-w-screen-md m-auto lg:ml-auto lg:mr-0 lg:max-w-screen-sm">
                <h1 className="text-5xl sm:text-6xl font-bold leading-none mb-6">
                  {landingBannerHeader}
                </h1>
                <p className="mb-6">{landingBannerMessage}</p>
                <div>
                  <a className={landingButtonClass} href="/#services">
                    LEARN MORE
                  </a>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-6/12 p-4">
              <div className="max-w-screen-md m-auto lg:max-w-none">
                <div className="shadow-xl">
                  <GatsbyImage
                    fluid={
                      landingBannerImage.contentImage.childImageSharp.fluid
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </LayoutContainer>
        <LightBackgroundSVG />
      </section>
      <section
        className="relative z-10 py-12 sm:py-20 text-white bg-teal-800 overflow-hidden"
        id="services"
      >
        <DarkBackgroundSVG />
        <LayoutContainer>
          <div className="relative">
            <h2 className="text-center text-5xl sm:text-6xl font-bold leading-none">
              What We Do
            </h2>
            <span className={`w-24 h-2 bg-teal-300 block my-8 m-auto`} />
            <div className="lg:max-w-full m-auto max-w-screen-md">
              <div className="grid gap-1 grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
                {landingServices.map(({ icon, header, message }) => {
                  return (
                    <LandingService
                      key={header}
                      header={header}
                      message={message}
                      IconComponent={iconMap[icon]}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        </LayoutContainer>
      </section>
      <section className="py-12 sm:py-20 bg-white">
        <LayoutContainer>
          <div className="lg:max-w-screen-xl m-auto max-w-screen-md">
            <h3 className="text-center text-2xl font-bold leading-none mb-6">
              We use the most trusted brands in cart manufacturing
            </h3>
            <div className="max-w-screen-md m-auto">
              <div className="flex flex-wrap items-center justify-center -mx-4">
                {Array.from({ length: 5 }).map((val, i) => {
                  return (
                    <div key={`logo-${i}`} className="p-4 w-6/12 lg:w-4/12">
                      <GatsbyImage
                        fluid={
                          pageData.content[`landingLogoImage${i + 1}`]
                            .contentImage.childImageSharp.fluid
                        }
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </LayoutContainer>
      </section>
      <section className="py-12 sm:py-20 bg-gray-100 text-center relative">
        <div className="hidden sm:block absolute top-0 left-0 text-teal-100 z-0 width-1/12">
          {TopAngleSVG}
        </div>
        <div className="hidden sm:block absolute bottom-0 right-0 text-teal-200 z-0 w-2/12">
          {BottomAngleSVG}
        </div>
        <div className="relative z-10">
          <LayoutContainer>
            <h2 className="text-5xl sm:text-6xl font-bold leading-none">
              What We Make
            </h2>
            <span className={`w-24 h-2 bg-teal-300 block my-8 m-auto`} />
            <div>
              <p className="mb-12 max-w-lg m-auto">{landingShowcaseTopText}</p>
              <div className="max-w-screen-lg m-auto mb-12">
                <div className="flex flex-wrap -m-2 items-end">
                  <div className="w-7/12 p-1 sm:p-2">
                    <div className="w-full shadow sm:shadow-lg">
                      <GatsbyImage
                        fluid={{
                          ...pageData.content.landingShowcaseImage1.contentImage
                            .childImageSharp.fluid,
                          aspectRatio: 6 / 4,
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-5/12 p-1 sm:p-2">
                    <div className="w-full shadow sm:shadow-lg">
                      <GatsbyImage
                        fluid={{
                          ...pageData.content.landingShowcaseImage2.contentImage
                            .childImageSharp.fluid,
                          aspectRatio: 1,
                        }}
                        imgStyle={{ objectPosition: "38% 50%" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap -m-2 items-start pt-2">
                  <div className="w-5/12 p-1 sm:p-2">
                    <div className="w-full shadow sm:shadow-lg mb-2 sm:mb-4">
                      <GatsbyImage
                        fluid={{
                          ...pageData.content.landingShowcaseImage3.contentImage
                            .childImageSharp.fluid,
                          aspectRatio: 7 / 5,
                        }}
                      />
                    </div>
                    <div className="w-full shadow sm:shadow-lg">
                      <GatsbyImage
                        fluid={{
                          ...pageData.content.landingShowcaseImage4.contentImage
                            .childImageSharp.fluid,
                          aspectRatio: 7 / 5,
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-7/12 p-1 sm:p-2">
                    <div className="w-full shadow sm:shadow-lg">
                      <GatsbyImage
                        fluid={{
                          ...pageData.content.landingShowcaseImage5.contentImage
                            .childImageSharp.fluid,
                          aspectRatio: 1,
                        }}
                        imgStyle={{ objectPosition: "88% 50%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p className="mb-4 max-w-lg m-auto">
                {landingShowcaseBottomText}
              </p>
              <div className="max-w-lg m-auto">
                <div className="flex flex-wrap -mx-2">
                  <div className="w-full sm:w-6/12 p-2">
                    <Link
                      to={SHOWCASE_ROUTE}
                      className="block w-full text-center shadow bg-teal-600 hover:bg-teal-500 focus:shadow-outline focus:outline-none text-white py-2 rounded"
                    >
                      VIEW SHOWCASE
                    </Link>
                  </div>
                  <div className="w-full sm:w-6/12 p-2">
                    <Link
                      to={FOR_SALE_ROUTE}
                      className="block w-full text-center shadow bg-white hover:bg-gray-100 focus:shadow-outline focus:outline-none text-black py-2 rounded"
                    >
                      SHOP PRODUCTS
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </LayoutContainer>
        </div>
      </section>
      <section className="py-12 sm:py-20 bg-white">
        <LayoutContainer>
          <div className="flex flex-wrap -m-4 md:flex-row-reverse">
            <div className="w-full lg:w-6/12 p-4">
              <div className="max-w-screen-md m-auto lg:ml-0 lg:mr-auto lg:max-w-screen-sm">
                <h2 className="text-5xl sm:text-6xl font-bold leading-none">
                  About Us
                </h2>
                <span className={`w-24 h-2 bg-teal-300 block my-8`} />
                <p className="mb-4">{landingAboutParagraph1}</p>
                <p className="mb-6">{landingAboutParagraph2}</p>
                <div>
                  <Link to={ABOUT_US_ROUTE} className={`${landingButtonClass}`}>
                    LEARN MORE
                  </Link>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-6/12 p-4">
              <div className="max-w-screen-md m-auto lg:max-w-none">
                <div className="w-10/12 shadow-lg relative">
                  <GatsbyImage
                    fluid={
                      pageData.content.landingAboutImage1.contentImage
                        .childImageSharp.fluid
                    }
                  />
                </div>
                <div className="w-7/12 shadow-lg relative -mt-24 ml-auto">
                  <GatsbyImage
                    fluid={{
                      ...pageData.content.landingAboutImage2.contentImage
                        .childImageSharp.fluid,
                      aspectRatio: 7 / 6,
                    }}
                    imgStyle={{ objectPosition: "100% 50%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </LayoutContainer>
      </section>
      <section className="relative py-12 sm:py-20 bg-gray-100">
        <LayoutContainer>
          <div className="lg:max-w-screen-xl m-auto max-w-screen-md relative z-10">
            <div className="flex flex-wrap -m-4">
              <div className="w-full lg:w-6/12 p-4">
                <h2 className="text-5xl sm:text-6xl font-bold leading-none">
                  Contact Us
                </h2>
                <span className={`w-24 h-2 bg-teal-300 block my-8`} />
                <p>{landingContactUsParagraph}</p>
              </div>
              <div className="w-full lg:w-6/12 p-4">
                <ContactForm />
              </div>
            </div>
          </div>
        </LayoutContainer>
        <LightBackgroundSVG />
      </section>
    </>
  )
}

export default () => {
  return (
    <Layout
      pageTitle="Street-Legal Golf Carts - Charlotte, NC"
      pageURL="/"
      pageDescription="QC Cart Craft is a federally authorized manufacturer specializing in custom cart builds and street-legal vehicle conversions for the greater Charlotte area."
      landingPage
    >
      <PageContainer />
    </Layout>
  )
}
